import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionService } from '@core/auth';
import { ResponsiveService } from '@core/services';
import { TranslocoModule } from '@jsverse/transloco';
import { PageAccountSettingsComponent } from '../settings';
import { PageAccountInformationComponent } from '../information';
import { PageAccountHelpComponent } from '../help';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matLogoutRound } from '@ng-icons/material-symbols/round';

@Component({
  selector: 'page-account-responsive',
  templateUrl: 'responsive.component.html',
  styleUrls: ['responsive.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PageAccountSettingsComponent,
    PageAccountInformationComponent,
    PageAccountHelpComponent,
    TranslocoModule,
    NgIconComponent,
  ],
  providers: [provideIcons({ matLogoutRound })],
})
export class PageAccountResponsiveComponent {
  _responsive = inject(ResponsiveService);
  private _session = inject(SessionService);

  logout(): void {
    this._session.logout();
  }
}
